import { UnitsEnums } from 'fabscale-app/models/enums/units';

export default function getUnitLabel(unit: string) {
  const unitLabel = new UnitsEnums().getLabel(unit);
  return unitLabel === '' ? '#' : unitLabel;
}
